import { Routes } from '@angular/router';

import betstationRoutes from './betstation.routes';
import bingoRoutes from './bingo.routes';
import casinoRoutes from './casino.routes';
import engagementRoutes from './engagement.routes';
import horseRacingRoutes from './horseracing.routes';
import lotteryRoutes from './lottery.routes';
import mobilePortalRoutes from './mobile-portal.routes';
import mokabingoRoutes from './mokabingo.routes';
import myaccountRoutes from './myaccount.routes';
import oxygenRoutes from './oxygen.routes';
import paymentsRoutes from './payments.routes';
import pokerRoutes from './poker.routes';
import promoRoutes from './promo.routes';
import sportsRoutes from './sports.routes';

export default [
    ...mobilePortalRoutes,
    ...oxygenRoutes,
    ...sportsRoutes,
    ...promoRoutes,
    ...myaccountRoutes,
    ...lotteryRoutes,
    ...horseRacingRoutes,
    ...bingoRoutes,
    ...mokabingoRoutes,
    ...casinoRoutes,
    ...pokerRoutes,
    ...engagementRoutes,
    ...paymentsRoutes,
    ...betstationRoutes,
] satisfies Routes;
